const API_NEWSLETTER_FIELDS = [
    'translations.title',
    'newsletter_page_items.translations.title',
    'newsletter_page_items.translations.url',
    'newsletter_page_items.translations.languages_code.lang'
];
export { API_NEWSLETTER_FIELDS };
